import { Lock, ArrowLeft, InfoIcon } from 'lucide-react'
import { wrapper, circle, icon } from './style.css'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function NotFound() {
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      if (window.history.length > 1) {
        navigate(-1)
      } else {
        navigate('/')
      }
    }, 3000)
  })

  return (
    <section className="d-flex flex-column justify-content-center align-items-center text-center">
      <div className={wrapper}>
        <motion.div
          className={circle}
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <Lock className={icon} />
        </motion.div>
      </div>

      <h4 className="mt-3 mb-2">このページは表示できません</h4>
      <p className="text-muted mb-4">ページが存在しないか、現在の状態では表示できません。</p>

      <Card border="danger" className="mb-4" style={{ maxWidth: 420 }}>
        <Card.Body>
          <Card.Title>考えられる理由</Card.Title>
          <Card.Text>
            <InfoIcon className="me-1" />
            ページが削除または移動された
          </Card.Text>
          <Card.Text>
            <InfoIcon className="me-1" />
            URL が正しくない
          </Card.Text>
          <Card.Text>
            <InfoIcon className="me-1" />
            現在の状態ではアクセスできない
          </Card.Text>
        </Card.Body>
      </Card>

      <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }}>
        <Button variant="outline-primary" onClick={() => navigate(-1)}>
          <ArrowLeft className="me-1" />
          前のページに戻る
        </Button>
      </motion.div>
    </section>
  )
}
